import { useState } from "react";
import { AddStaffLevel } from "./add-staff-level-dialog";
import { EditStaffLevelDialog } from "./edit-staff-level-dialog";
import { DeleteStaffLevelDialog } from "./delete-staff-level-dialog";
import StaffLevelsTable from "./staff-levels-table";
import type { StaffLevel } from "@/types/staff/api-types/staff-level-types";

export const StaffLevelsTabContent = () => {
  const [selectedStaffLevel, setSelectedStaffLevel] = useState<StaffLevel | null>(null);
  const [isEditDialogOpen, setIsEditDialogOpen] = useState(false);
  const [staffLevelToDelete, setStaffLevelToDelete] = useState<StaffLevel | null>(null);
  const [isDeleteDialogOpen, setIsDeleteDialogOpen] = useState(false);

  const handleStaffLevelClick = (staffLevel: StaffLevel) => {
    setSelectedStaffLevel(staffLevel);
    setIsEditDialogOpen(true);
  };

  const handleEditDialogClose = (open: boolean) => {
    setIsEditDialogOpen(open);
    if (!open) {
      setSelectedStaffLevel(null);
    }
  };

  const handleDeleteClick = (staffLevel: StaffLevel) => {
    setStaffLevelToDelete(staffLevel);
    setIsDeleteDialogOpen(true);
  };

  const handleDeleteDialogClose = (open: boolean) => {
    setIsDeleteDialogOpen(open);
    if (!open) {
      setStaffLevelToDelete(null);
    }
  };

  return (
    <div className="mt-5">
      <div className="flex justify-end mb-4 pr-4">
        <AddStaffLevel />
      </div>
      <StaffLevelsTable
        onStaffLevelClick={handleStaffLevelClick}
        onDeleteClick={handleDeleteClick}
      />
      {selectedStaffLevel && (
        <EditStaffLevelDialog
          staffLevel={selectedStaffLevel}
          open={isEditDialogOpen}
          onOpenChange={handleEditDialogClose}
        />
      )}
      {staffLevelToDelete && (
        <DeleteStaffLevelDialog
          staffLevel={staffLevelToDelete}
          open={isDeleteDialogOpen}
          onOpenChange={handleDeleteDialogClose}
        />
      )}
    </div>
  );
};